const TransferAlt = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9241 10.383C19.9998 10.2002 20.0196 9.99907 19.981 9.80505C19.9424 9.61102 19.847 9.43281 19.7071 9.29297L14.7071 4.29297L13.2931 5.70697L16.5861 8.99997H4.00012V11H19.0001C19.1979 11 19.3912 10.9414 19.5557 10.8316C19.7202 10.7218 19.8484 10.5657 19.9241 10.383ZM4.07612 13.617C4.00041 13.7997 3.98062 14.0009 4.01925 14.1949C4.05787 14.3889 4.15318 14.5671 4.29312 14.707L9.29312 19.707L10.7071 18.293L7.41412 15H20.0001V13H5.00012C4.80232 12.9998 4.60892 13.0583 4.44443 13.1682C4.27993 13.278 4.15175 13.4342 4.07612 13.617Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default TransferAlt;
